<div class="row">
  <div class="col text-center">
    <span class="font-weight-bold my-2">{{ 'audits.audit.fields.picture'+index | translate }}</span>
  </div>
</div>

@if (readonly) {
  @if (!pictureSrc && !pictureImage) {
    <div class="row"> <!-- NO picture-->
      <div class="col text-center">
        <div class="col text-center">
          <p class="mt-2">{{ 'base.notpresent' | translate }}</p>
        </div>
      </div>
    </div>
  }
  @if (pictureSrc) {
    <div class="row">
      <div class="col">
        <img class="img-fluid img-thumbnail" [src]="pictureSrc" (load)="pictureImage = loadBackgroundImage($event.target, pictureSrc, false)">
        @if (pictureImage) {
          <div class="img-fluid img-thumbnail preview" [class.d-none]="true">
            <ng-opendraw extOpenDraw
              [backgroundImage]="pictureImage"
              [canWidth]='pictureImage.width'
              [canHeight]='pictureImage.height'
              [eraser]="false"
              [fillShape]="false"
              [lineWidth]="pictureLineWidth"
              [lineColor]="pictureLineColor"
              [drawStyle]="pictureDrawStyle"
              [eraser]="pictureEraser"
              [allowedDeviceType]="allowedDeviceType"
              [commandObs]='pictureCmd$'
              (outputEvent)="pictureSrc = processResult($event)"
              (errorEvent)="processError($event)"
            ></ng-opendraw>
          </div>
        }
      </div>
    </div>
  }
}



@if (!readonly) {
  @if (!pictureSrc && !pictureImage) {
    <div class="row"> <!-- NO picture-->
      <div class="col text-center">
        <div class="col text-center">
          <p class="mt-2">{{ 'base.notpresent' | translate }}</p>
          <label for="upload" class="mt-2 file-upload">
            <s1-button [type]="s1ButtonType.Browse" [type]="s1ButtonType.Upload"></s1-button>
            <input id="upload" type="file" ng2FileSelect [uploader]="uploader" (onFileSelected)="fileSelected()" (change)="fileChanged($event)"/>
            @if (exeecedSizeError) {
              <p class="mt-2 text-danger">{{ 'msg.file_size_exceeds' | translate }}</p>
            }
            @if (imageFormatError) {
              <p class="mt-2 text-danger">{{ 'msg.file_format_error' | translate }}</p>
            }
          </label>
        </div>
      </div>
    </div>
  }
  @if (pictureSrc && pictureDeletable) {
    <div class="row">  <!-- YES picture, YES deleting -->
      <div class="col text-center">
        <p class="mt-4 text-danger"><em class="mr-2 fa fas fa-exclamation"></em>{{ 'audits.audit.popup.confirmDelete' | translate }}</p>
        <p class="mt-2">{{ 'base.or' | translate }}
          <s1-button class="ml-2" (onClick)="pictureDeletable = false" [type]="s1ButtonType.Cancel" [label]="'audits.audit.popup.undoDeletePicture'"></s1-button>
        </p>
      </div>
    </div>
  }
  @if (pictureSrc && pictureUpdatable) {
    <div class="row">  <!-- YES picture, YES updating -->
      <div class="col text-center">
        <label for="upload" class="mt-2 file-upload">
          <s1-button [type]="s1ButtonType.Browse" [type]="s1ButtonType.Upload"></s1-button>
          <input id="upload" type="file" ng2FileSelect [uploader]="uploader" (onFileSelected)="fileSelected()" (change)="fileChanged($event)"/>
          @if (exeecedSizeError) {
            <p class="mt-2 text-danger">{{ 'msg.file_size_exceeds' | translate }}</p>
          }
          @if (imageFormatError) {
            <p class="mt-2 text-danger">{{ 'msg.file_format_error' | translate }}</p>
          }
        </label>
        <p class="mt-2">{{ 'base.or' | translate }}
          <s1-button class="ml-2" (onClick)="pictureUpdatable = false" [type]="s1ButtonType.Cancel" [label]="'audits.audit.popup.undoDeletePicture'"></s1-button>
        </p>
      </div>
    </div>
  }
  @if (pictureSrc && !pictureDeletable && !pictureUpdatable) {
    <!-- YES picture, NO deleting, updating -->
    <div class="row">
      <div class="col text-right mt-2 mb-1">
        @if (pictureAction == 'crop') {
          <s1-button (onClick)="pictureAction = 'draw'; switchAction(pictureAction)" [type]="s1ButtonType.Normal" [label]="'base.draw'" icon="icon-pencil" class="mr-2"></s1-button>
        }
        @if (pictureAction == 'draw') {
          <s1-button (onClick)="pictureAction = 'crop'; switchAction(pictureAction)" [type]="s1ButtonType.Normal" [label]="'base.crop'" icon="icon-frame" class="mr-2"></s1-button>
        }
        <s1-button (onClick)="pictureUpdatable = true; updatePicture()" [type]="s1ButtonType.Cancel" icon="icon-camera" label="base.change" class="mr-2"></s1-button>
        @if (pictureSrcOriginal) {
          <s1-button  (onClick)="pictureDeletable = true; updatePicture()" [type]="s1ButtonType.Delete"></s1-button>
        }
      </div>
    </div>
    <div class="row mt-2">
      <div class="col text-center mb-1">
        <!-- PICTURE DRAW -->
        @if (pictureAction == 'draw') {
          <div class="btn-group mr-2" dropdown>
            <a class="dropdown-toggle pointer bg-gray-light p-1" dropdownToggle><em style="font-size: 24px;" class="fa-2x fas fa-circle" [ngClass]="pictureSelectionColor"></em></a>
            <div *dropdownMenu class="dropdown-menu bg-gray-light" style="min-width: 50px">
              <a class="dropdown-item pointer" (click)="changeColor('text-black')"><em class="fa-2x fas fa-circle text-black"></em></a>
              <a class="dropdown-item pointer" (click)="changeColor('text-white')"><em class="fa-2x fas fa-circle text-white"></em></a>
              <a class="dropdown-item pointer" (click)="changeColor('text-danger')"><em class="fa-2x fas fa-circle text-danger"></em></a>
              <a class="dropdown-item pointer" (click)="changeColor('text-yellow')"><em class="fa-2x fas fa-circle text-yellow"></em></a>
            </div>
          </div>
          <div class="btn-group mr-2" dropdown>
            <a class="dropdown-toggle pointer bg-gray-light p-2" dropdownToggle><span>{{pictureSelectionDrawStyle}}</span></a>
            <div *dropdownMenu class="dropdown-menu bg-gray-light" style="min-width: 50px">
              <a class="dropdown-item pointer" (click)="changeDrawLine(drawStyle.LINE)">{{'base.line' | translate }}</a>
              <a class="dropdown-item pointer" (click)="changeDrawLine(drawStyle.ELLIPSE)">{{'base.circle' | translate }}</a>
              <a class="dropdown-item pointer" (click)="changeDrawLine('eraser')">{{'base.eraser' | translate }}</a>
            </div>
            <s1-button (onClick)="resetPicture()" [onlyIcon]="false" label="base.reset" [type]="s1ButtonType.Cancel" icon="fas fa-arrow-left" class="ml-1"></s1-button>
          </div>
        }
        <!-- PICTURE CROP -->
        @if (pictureAction == 'crop') {
          <span>{{ 'base.cropConfirm' | translate }}</span>
          <s1-button (onClick)="pictureSrc = switchAction('draw', pictureCropped); pictureAction = 'draw';" [onlyIcon]="true" [type]="s1ButtonType.Check" class="ml-2"></s1-button>
        }
      </div>
    </div>
  }
  @if (pictureSrc && !pictureDeletable && !pictureUpdatable && pictureAction == 'draw') {
    <div class="row">  <!-- YES picture, drawing -->
      <div class="col">
        <img class="img-fluid img-thumbnail" [src]="pictureSrc" (load)="pictureImage = loadBackgroundImage($event.target, pictureSrc)">
        @if (pictureImage) {
          <div class="img-fluid img-thumbnail preview" [class.pointer-eraser]="pictureEraser" [class.pointer-circle]="pictureDrawStyle == drawStyle.ELLIPSE" [class.d-none]="pictureDeletable">
            <ng-opendraw extOpenDraw
              [backgroundImage]="pictureImage"
              [canWidth]='pictureImage.width'
              [canHeight]='pictureImage.height'
              [eraser]="false"
              [fillShape]="false"
              [lineWidth]="pictureLineWidth"
              [lineColor]="pictureLineColor"
              [drawStyle]="pictureDrawStyle"
              [eraser]="pictureEraser"
              [allowedDeviceType]="allowedDeviceType"
              [commandObs]='pictureCmd$'
              (outputEvent)="pictureSrc = processResult($event)"
              (errorEvent)="processError($event)"
            ></ng-opendraw>
          </div>
        }
      </div>
    </div>
  }
  @if (pictureSrc && !pictureDeletable && !pictureUpdatable && pictureAction == 'crop') {
    <div class="row">  <!-- YES picture, cropping -->
      <div class="col">
        @if (pictureImage) {
          <image-cropper
            [imageURL]="pictureSrc"
            [maintainAspectRatio]="false"
            output="base64"
            format="jpeg"
            (imageCropped)="pictureCropped = imageCropped($event)"
          ></image-cropper>
        }
      </div>
    </div>
  }
}

